<!--  -->
<template>
<div class='' v-show="show" style="height:90%">
   <div style="margin-bottom:10px;display:flex;justify-content:flex-start;">
      <el-button  type="success" icon="el-icon-plus" @click="addData()" plain>添加数据</el-button>
      <div style="width:300px;display:flex;justify-content:space-between;margin-left:10px">
        <el-input style="margin-right:10px" v-model="condition.title" placeholder="请输入内容"></el-input> <el-button type="success" size="mini" @click="queryByName()" round>搜素</el-button>
      </div>
    </div>
      <el-table
        :data="tableData.list"
        style="width: 100%;height:85%;overflow: scroll;">
        <el-table-column
          label="背景图"
          width="180">
          <template slot-scope="scope">
            <el-image style="width: 150px; height: 100px" :src="scope.row.backImg" fit="scale-down"></el-image>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="分类名称"
          width="180">
        </el-table-column>
        <el-table-column
          prop="num"
          label="浏览次数"
          width="180">
        </el-table-column>
        <el-table-column
          prop="ifshow"
          label="是否展示"
          width="180">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.ifshow"
              @change="changeDisplay(scope.row,scope.$index)"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="发布时间"
          width="180">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              style="margin-right:10px"
              @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-popconfirm
                confirm-button-text='确定'
                cancel-button-text='不用了'
                icon="el-icon-info"
                icon-color="red"
                @confirm="handleDelete(scope.$index, scope.row)"
                :title="numOfClassify>0?`该分类有 (${numOfClassify}) 个数据,删除该分类这些数据一并会被删除,确定删除吗？`:'该分类无数据,确定删除吗？'">
                <el-button
                size="mini"
                type="danger"
                slot="reference" @click="confirmNumOfClassify(scope.row.id)">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        style="margin-top:10px"
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :total="tableData.totalCount"
        :page-size="tableData.pageSize">
      </el-pagination>
      <el-dialog title="编辑" :visible.sync="dialogFormVisible" width="40%" append-to-body>
        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item style="display:none">
          <el-input v-model="form.id" clearable></el-input>
          </el-form-item>
          <el-form-item label="分类图片" prop="backImg" label-width="120px">
            <s-upload-img :getImageUrl="getBackImg" :url="form.backImg"></s-upload-img>
          </el-form-item>
          <el-form-item label="分类名称" prop="name" label-width="120px">
           <el-input v-model="form.name" clearable></el-input>
          </el-form-item>
          <el-form-item label="分类排序" prop="sort" label-width="120px">
           <el-input v-model="form.sort" clearable></el-input>
          </el-form-item>
          <el-form-item label="是否展示" label-width="120px">
            <el-switch
              v-model="form.ifshow"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="submit('form')">{{(form.id==""||form.id==undefined)?'添加资讯信息':'更新资讯信息'}}</el-button>
        </div>
      </el-dialog>
</div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import sUploadImg from '@/components/SingleImgUpload'
import {insert,update,query,queryList,deleted} from '@/api/admin/corporateImageSort.js'
import {queryNumOfTheClassify} from '@/api/admin/corporateImageList.js'
export default {
//import引入的组件需要注入到对象中才能使用
components: {sUploadImg},
data() {
//这里存放数据
return {
  dialogFormVisible:false,
  show:false,
  numOfClassify:0,
  condition:{
    current:1,
    size:5,
    title:""
  },
  tableData:{
    totalCount:1,
    pageSize:1,
    totalPage:1,
    currPage:1,
    list:[]
  },
  form:{
    id:"",
    backImg:"",
    name:"",
    sort:0,
    ifshow:false
  },
  rules:{
  backImg:{required:true,message:"背景图不能为空",trigger:'blur'},
  name:{required:true,message:"分类名称不能为空",trigger:'blur'}
  }
    };
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
  confirmNumOfClassify(id){
    var _this = this
    queryNumOfTheClassify({"classify":id}).then(({data})=>{
      _this.numOfClassify=data
    })
  },
  queryByName(){
    var _this = this
    _this.condition.current=1
    queryList(_this.condition).then(({data})=>{
      _this.tableData=data
    })
  },
  getBackImg(val){
   this.form.backImg = val
  },
  addData(){
    this.dialogFormVisible=true;
    this.form ={id:"",backImg:"",name:"",ifshow:false,sort:0}
  },
  handleDelete(index) {
  var _this = this
  deleted(_this.tableData.list[index]).then(()=>{
    if((_this.tableData.totalCount%_this.condition.size==1)&&_this.tableData.totalCount!=1&&_this.condition.current==_this.tableData.totalPage){
      _this.condition.current=_this.condition.current-1
    }
    _this.$message.success("删除成功!")
    queryList(_this.condition).then(({data})=>{
      _this.tableData=data
    })
  })
  },
  handleEdit(index, row){
    console.log(index)
    var _this =this
    query({id:row.id}).then(({data})=>{
      let {id,backImg,name,ifshow,sort}=data
      _this.form.id=id
      _this.form.backImg=backImg
      _this.form.name=name
      _this.form.ifshow=ifshow
      _this.form.sort=sort
    })
    this.dialogFormVisible=true
  },
  submit(name){
    var _this = this
    this.$refs[name].validate((valid)=>{
      if(valid){
        if(!(_this.form.id!=null&&_this.form.id!=""&&_this.form.id!=undefined)){
             insert(_this.form).then(()=>{
              this.$message.success("添加成功")
              _this.dialogFormVisible=false
              queryList(_this.condition).then(({data})=>{
                if(data!=null){
                _this.tableData = data
                }
              })
             })
        }else{
             update(_this.form).then(()=>{
              this.$message.success("更新成功")
                queryList(_this.condition).then(({data})=>{
                  if(data!=null){
                  _this.tableData = data
                  }
                })
             })
        }
      }else{
        this.$message.info("请填写完整信息")
      }
    })
  },
  changeDisplay(row,index){
      var _this = this
      var num = 0
      this.tableData.list.forEach((s)=>{
         if(s.ifshow){
          num=num+1
         }
      })
      if(num>=4&&!row.ifshow){
        this.$message.info("显示的分类不能大于4个")
        return;
      }
      update({id:row.id,ifshow:!row.ifshow}).then(()=>{
          _this.$message.success("更新成功!")
      })
      this.tableData.list[index].ifshow=!row.ifshow
  },
  handleCurrentChange(val){
    var _this =this
    _this.condition.current = val
    queryList(_this.condition).then(({data})=>{
    _this.tableData=data
   })
  }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
 this.show=true
 var _this = this
 queryList(_this.condition).then(({data})=>{
  if(data!=null){
  _this.tableData = data
  }
 })
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
/** scoped 表示 样式自在当前组件有效*/
//@import url(); 引入公共css类

</style>